import {
  useWSModal,
  WSActions,
  WSAlert,
  WSElement,
  WSText
} from "@wingspanhq/fe-component-library";
import { IRequirementDefinitionResponse } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { DefaultActionDetails } from "../components/DefaultActionDetails";

export interface DeleteNotAllowedModalProps {
  requirementDefinition: IRequirementDefinitionResponse;
  engagementLength: number;
  onClose: () => void;
}

export const DeleteNotAllowedModal: React.FC<DeleteNotAllowedModalProps> = ({
  requirementDefinition,
  engagementLength,
  onClose
}) => {
  return (
    <>
      <DefaultActionDetails
        requirementDefinition={requirementDefinition}
        engagementLength={engagementLength}
      />

      <WSAlert
        my="2XL"
        theme="warning"
        icon="alert"
        size="M"
        title="Requirement cannot be deleted when:"
      >
        <WSElement as="ul" ml="L">
          <li>Associated with active engagements types.</li>
          <li>Historical data (e.g. requirement completion) exists.</li>
        </WSElement>
        <WSText.ParagraphSm mt="M" weight="book">
          If this requirement is no longer used, it can be archived instead.
        </WSText.ParagraphSm>
      </WSAlert>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Done",
            onClick: onClose,
            kind: "Secondary"
          }
        ]}
      />
    </>
  );
};

export const useDeleteNotAllowedModal = () => {
  return useWSModal(DeleteNotAllowedModal, {
    title: "Delete requirement",
    size: "M"
  });
};
